import { html } from "htm/preact";
import { hydrate } from "preact";
import LocaleSwitcherHeader from "../components/LocaleSwitcherHeader.js";

const containers = document.querySelectorAll("[data-locale-switcher-header]");
const locales = JSON.parse(document.getElementById("locales-header").innerHTML);
const pages = JSON.parse(document.getElementById("pages-header").textContent);

containers.forEach((el) => {
  if (el) {
    const lang = el.dataset.lang;

    hydrate(html`<${LocaleSwitcherHeader} lang=${lang} locales=${locales} pages=${pages} />`, el);
  }
})
